<template>
<div :class="`player dice-${dice.length}`" :id="id">
    <div :class="`cup ${isActivePlayer ? 'active' : ''} ${visibility}`" @click="Shuffle">

        <div v-if="showDice" class="dice-container">
            <div v-for="(die, index) in dice" :key="index" :class="`die-${die}`">
                {{ diceData[die].icon }}
            </div>
        </div>
        <div v-else>{{dice.length}}</div>

        <div class="reserve" v-show="reserve">{{ reserve }}</div>

    </div>

    <div class="actions">

        <div v-if="isActivePlayer">
            <button @click="RemoveDie">-</button>

            <select v-model="currentVisibility">
                <option value="self">yo</option>
                <option value="others">otros</option>
                <option value="closed">nadie</option>
                <option value="open">todos</option>
            </select>

            <button @click="AddDie">+</button>

            <!--<button  @click="Shuffle">shuffle</button>-->
        </div>
        <div v-else class="player-name">{{ name }}</div>

    </div>

</div>
</template>

<script>
export default {
    props: {
        isActivePlayer: {type: Boolean, default: false},
        id: {type: String, default: ''},
        name: {type: String, default: 'guest'},
        dice: {type: Array, default: () => []},
        reserve: {type: Number, default: 0},
        visibility: {type: String, default: 'self'},
    },
    data() {
        return {
            currentVisibility: 'self',
            canShuffle: true,
            diceData: {
                1: {icon: '⚀', color: 'white'},
                2: {icon: '⚁', color: 'white'},
                3: {icon: '⚂', color: 'white'},
                4: {icon: '⚃', color: 'white'},
                5: {icon: '⚄', color: 'white'},
                6: {icon: '⚅', color: 'white'},
            }
        }
    },
    methods: {
        Shuffle()
        {
            if(!this.isActivePlayer) return;
            if(!this.canShuffle) return;
            this.$socket.client.emit('SHUFFLE');
            this.canShuffle = false;
            setTimeout(() => {
                this.canShuffle = true;
            }, 600);
        },
        AddDie()
        {
            this.$socket.client.emit('ADD_DICE');
        },
        RemoveDie()
        {
            this.$socket.client.emit('REMOVE_DICE');
        }
    },
    computed: {
        showDice() {
            if(this.visibility == 'open') return true;
            if(this.isActivePlayer && this.visibility == 'self') return true;
            if(!this.isActivePlayer && this.visibility == 'others') return true; 
            return false;
        }
    },
    watch: {
        currentVisibility(n, o) {
            this.$socket.client.emit('SET_VISIBILITY', n);
        }
    }
}
</script>

<style lang="scss">
.player {
    display: flex;
    flex-direction: column;
    align-items: center;

    &.dice-0 {
        opacity: 0.5;
    }

}
.cup {
    position: relative;
    width: 100px;
    height: 100px;
    border: 3px solid white;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 40px;
    user-select: none;

    &.active {
        cursor: pointer;
    }

    &:not(.active).self {
        border-top-color: transparent;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    &:not(.active).others {
        border-bottom-color: transparent;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    &.active.others {
        border-top-color: transparent;
        border-top-left-radius: 0px;
        border-top-right-radius: 0px;
    }

    &.active.self {
        border-bottom-color: transparent;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    &.open {
        border-style: dashed;
    }

}

.dice-container {
    display: flex;
    justify-content: center;
    font-size: 32px;
    flex-wrap: wrap;
    line-height: 0.8;
    padding: 12px 10px 10px 10px;
}

.reserve {
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333f66;
    font-size: 16px;
    font-weight: bolder;
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    border-radius: 10px;
}

.actions {
    margin-top: 10px;
    text-align: center;
    color: white;
    
    button, select {
        border: none;
        background: transparent;
        color: white;
        border: 2px solid white;
        border-radius: 5px;
        opacity: 0.6;
        cursor: pointer;
        margin: 0px 2px;

        &:hover {
            opacity: 1;
        }
    }

    option {
        background: black;
    }

}

.die-1 {
    //color: #e55d57;
    color: white;
}
.die-2 {
    color: #f4e775;
}
.die-3 {
    color: #ff7c60;
}
.die-4 {
    color: #b676e8;
}
.die-5 {
    color: #86c8e9;
}
.die-6 {
    color: #b5e167;
}

.player-name {
    max-width: 100px;
    overflow: hidden;
}

.shake {
    animation: anim-shake 0.4s ease-in-out;
}

@keyframes anim-shake {
  0% { transform: translateY(0) }
  20% { transform: translateY(5px) }
  40% { transform: translateY(-5px) }
  60% { transform: translateY(5px) }
  80% { transform: translateY(-5px) }
  100% { transform: translateY(0) }
}

</style>